import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Form, Button } from "react-bootstrap";
import { Check, X } from "lucide-react";
import { Icon } from "@iconify/react";
import "./ShoppingLists.css";

const ItemStagingPanel = ({ stagedItem, onSave, onCancel, onChange }) => {
    if (!stagedItem) return null;

    return (
        <AnimatePresence mode="wait">
            {stagedItem && (
                <motion.div
                    key={stagedItem.tmpId || "staged-panel"}
                    className="w-100 mb-3"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                >
                    <div className="bg-white border rounded-4 p-3 shadow-sm d-flex flex-column gap-2">

                        {/* Header: Icon + Name + Close */}
                        <div className="d-flex align-items-center gap-3">
                            <div className="d-flex justify-content-center align-items-center rounded-circle bg-light flex-shrink-0" style={{ width: "48px", height: "48px" }}>
                                {stagedItem.icon && stagedItem.icon.startsWith('http') ? (
                                    <img src={stagedItem.icon} alt="" style={{ width: "60%", height: "60%", objectFit: "contain" }} />
                                ) : (
                                    <Icon icon={stagedItem.icon || "lucide:shopping-cart"} width="24" height="24" color="#555" />
                                )}
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                                <h6 className="fw-bold mb-0 text-truncate">{stagedItem.name}</h6>
                                <small className="text-muted">Details anpassen</small>
                            </div>
                            <div className="cursor-pointer text-muted p-1" onClick={onCancel}>
                                <X size={18} />
                            </div>
                        </div>

                        {/* Inputs Row */}
                        <div className="d-flex gap-2">
                            <div style={{ width: "30%" }}>
                                <Form.Control
                                    size="sm"
                                    type="number"
                                    placeholder="Menge"
                                    value={stagedItem.quantity}
                                    onChange={(e) => onChange({ ...stagedItem, quantity: e.target.value })}
                                    className="text-center bg-light border-0"
                                />
                            </div>
                            <div style={{ width: "30%" }}>
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    placeholder="Einheit"
                                    value={stagedItem.unit}
                                    onChange={(e) => onChange({ ...stagedItem, unit: e.target.value })}
                                    className="text-center bg-light border-0"
                                />
                            </div>
                            <div className="flex-grow-1">
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    placeholder="Hinweis..."
                                    value={stagedItem.propertiesDescription}
                                    onChange={(e) => onChange({ ...stagedItem, propertiesDescription: e.target.value })}
                                    className="bg-light border-0"
                                />
                            </div>
                        </div>

                        {/* Save Button (Optional, since Enter on main input saves too, but good to have) */}
                        <Button
                            variant="light"
                            size="sm"
                            className="w-100 rounded-3 fw-bold d-flex align-items-center justify-content-center gap-2 mt-1 text-primary"
                            onClick={onSave}
                        >
                            <Check size={16} /> Fertig
                        </Button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ItemStagingPanel;
